<script setup>

import {ref} from "vue";

const props = defineProps({
    duplicates: {
        type: Number,
        required: true
    },
    templateUrl: {
        type: String,
        required: true
    },
    downloadUrl: {
        type: String,
        required: true
    },
    canArchive: {
        type: Boolean,
        default: false
    }
})

const addingContact = ref(false)
const addingContactBy = ref('form')
const leadImport = ref(null)

const openImport = () => {
    leadImport.value.open()
}

const exportLeads = () => {
    window.location.href = props.downloadUrl
}

const manageDuplicates = () => {
    window.location.href = route('crm.duplicates')
}

const manageArchived = () => {
    window.location.href = route('crm.leads.archived')
}

</script>
<template>
    <div>
        <div class="md:sticky top-2 z-topbar">
            <frosted-bar>
                <div class="flex items-center justify-between space-x-4">
                    <h1>{{ _mft('crm:contacts') }}</h1>
                    <div class="text-right flex items-center space-x-2">
                        <button-more-options
                            size="md"
                            alignment="right"
                            options-class="min-w-56 text-left"
                            :cancel-on-outside-click="false"
                        >
                            <button-more-options-option
                                class="whitespace-nowrap"
                                @click="openImport"
                            >
                                <i class="mr-2 fa-light fa-download"></i>
                                {{ _mft('crm:leadImport.title') }}
                            </button-more-options-option>
                            <button-more-options-option
                                class="whitespace-nowrap"
                                @click="exportLeads"
                            >
                                <i class="mr-2 fa-light fa-upload"></i>
                                {{ _mft('shared:export') }}
                            </button-more-options-option>
                            <button-more-options-option
                                v-if="props.duplicates > 0"
                                class="whitespace-nowrap"
                                @click="manageDuplicates"
                            >
                                <i class="mr-2 fa-light fa-clone"></i>
                                {{ _mft('crm:manageDuplicates', {count: props.duplicates}) }}
                            </button-more-options-option>
                            <button-more-options-option
                                class="whitespace-nowrap"
                                @click="manageArchived"
                            >
                                <i class="mr-2 fa-light fa-box-archive"></i>
                                {{ _mft('crm:archive.manage') }}
                            </button-more-options-option>
                        </button-more-options>
                        <crm-lead-import
                            ref="leadImport"
                            :template-url="props.templateUrl"
                            :show-trigger="false"
                        />
                        <button-primary
                            @click="addingContact = true"
                        >{{ _mft('crm:addContact') }}</button-primary>
                    </div>
                </div>
            </frosted-bar>
        </div>
        <filter-leads-index
            :can-archive="props.canArchive"
        ></filter-leads-index>

        <slideout-with-slots
            v-if="addingContact"
            @close="addingContact = false"
        >
            <template #title>
                <h2>
                    {{ addingContactBy === 'form' ? _mft('crm:addContact') : _mft('crm:addFromLinkedin') }}
                </h2>
            </template>
            <template #body>
                <div class="flex justify-end">
                    <button-secondary
                        v-if="addingContactBy === 'form'"
                        size="sm"
                        @click="addingContactBy = 'linkedin'"
                    >
                        {{ _mft('crm:addFromLinkedin') }}
                    </button-secondary>
                    <button-secondary
                        v-if="addingContactBy === 'linkedin'"
                        size="sm"
                        @click="addingContactBy = 'form'"
                    >
                        {{ _mft('crm:addFromForm') }}
                    </button-secondary>
                </div>
                <form-lead-create
                    v-if="addingContactBy === 'form'"
                    class="mt-4"
                />
                <div
                    v-if="addingContactBy === 'linkedin'"
                    class="mt-4"
                >
                    <form-lead-create-from-linkedin />
                </div>
            </template>
        </slideout-with-slots>
    </div>
</template>
